import concat from "lodash/concat";

import { METRICS_BY_CONTROLLER } from "../components/Report/Tab/metricsByController";
import type { MetricEntity, TrafficShareMetricSchema } from "../types/api.types";

export const getInitialMetricsStructure = () => {
    const generalMetricsList = concat(...Object.values(METRICS_BY_CONTROLLER));

    return generalMetricsList.reduce(
        (acc, curr) => ({ ...acc, [curr]: { isLoading: true, isError: false, isFetched: false } }),
        {},
    );
};

export const getIsMetricsFetched = (metrics: Record<string, MetricEntity | TrafficShareMetricSchema> | null) =>
    metrics ? Object.values(metrics).every((metric) => metric.isFetched) : false;
